import { CheckPower } from '@/utils/powerConsts.js';

/**
 *  如果没有权限则移除el本身
 *  <button v-permission='权限id'>审核</button>
 */
function hasPermission(el, binding) {
    const hasPermission = CheckPower(binding.value);
    if (!hasPermission) {
        // el.style.display = 'inline-block';
        el && el.remove();
    }
}

export default {
    // bind: hasPermission,
    inserted: hasPermission,
    update: hasPermission,
};
